// extracted by mini-css-extract-plugin
export default {"root":"Orpm5","initialized":"gTbAi","testNodeWrapper":"yHmE4","testText":"cHxP9"};